import { Box, Modal} from "@mui/material";
import { ModalStyle } from "../../../../helpers/appHelpers";
import { SubscriptionTierDto } from "../../../../models/subscription-tier.dto";
import { IoMdClose } from "react-icons/io";
import { TransactionHistoryColumns } from "../../../shared/account_settings/nav/subscription/data";
import CustomPagination from "../../../../components/table/CustomPagination";
import { useGetOrgTransaction } from "../../../../services/organization-transaction.service";
import { OrganizationTransaction } from "../../../../models/organization-transaction.dto";
import CustomStyledTable from "../../../../components/table/CustomStyledTable";
import { useManageTableWithStateVariables } from "../../../../helpers/useManageTable";

interface ITransactionHistory {
	organizationId: string;
	subscriptionPackage: SubscriptionTierDto | undefined;
	openTransactionHistory: boolean;
	setOpenTransactionHistory: React.Dispatch<React.SetStateAction<boolean>>;
}

const TransactionHistory = ({
	organizationId,
	subscriptionPackage,
	openTransactionHistory,
	setOpenTransactionHistory,
}: ITransactionHistory) => {
	const {
		tableAPIRef,
		tableData,
		isLoading,
		page,
		pageCount,
		handlePageChange,
	} = useManageTableWithStateVariables<OrganizationTransaction>({ 
		fetchHook: useGetOrgTransaction,
		options: { organizationId }
	});

	return (
		<Modal
			open={openTransactionHistory}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box sx={ModalStyle} width={1260} fontSize={"13px"}>
				<div className="flex justify-between items-center pt-4 pb-6">
					<div className="flex items-center gap-5">
						<h1 className="font-bold text-lg">Transaction History</h1>
						<div className="bg-[#6978F0] font-semibold text-white whitespace-nowrap 
							text-xs px-2 py-[6px] rounded flex items-center justify-center"
						>
							<p>{subscriptionPackage?.name}</p>
						</div>
					</div>
					<button
						onClick={() => setOpenTransactionHistory(false)}
					>
						<IoMdClose className="text-xl hover:scale-[1.1]" />
					</button>
				</div>
				<hr className="mb-6"/>
				<CustomStyledTable
					rows={tableData}
					columns={TransactionHistoryColumns}
					apiRef={tableAPIRef}
					loading={isLoading}
					pageCount={pageCount}
					pagination={
						<CustomPagination 
							pageCount={pageCount} 
							pageState={page}
							handleChange={handlePageChange}
						/>
					}
				/>
			</Box>
		</Modal>
	);
};

export default TransactionHistory;
